import { imagePrefixCls } from "@/base/components/image/Image.component";
import { THEME_PREFIX } from "@/base/constant";
import {
  genComponentStyleHook,
  type FullToken,
  type GenerateStyle,
} from "antd/es/theme/internal";

const genStyle: GenerateStyle<FullToken<"Image">> = () => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${imagePrefixCls}`]: {},
  },
});

export const useImageStyle = genComponentStyleHook(
  ["Image", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
